// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"f89f746a","297":"bf695849","643":"2a966886","878":"0b7da2bb"}[chunkId] + ".chunk.js";
};